import styled from "styled-components";
import { Heading } from "@aidron/aidron-ds";

const colors = [
  { name: "orange", code: "#e75d0d" },
  { name: "mediumGrey", code: "#5f5e5e" },
  { name: "white", code: "#ffffff" },
  { name: "orangeGrey", code: "#b19585" },
  { name: "cloud", code: "#f8fafc" },
  { name: "mist", code: "#f1f5f9" },
  { name: "silverSoft", code: "#e2e8f0" },
  { name: "fog", code: "#e5e7eb" },
  { name: "stoneLight", code: "#d6dbe1" },
  { name: "lightGrey1", code: "#f9fafb" },
  { name: "lightGrey2", code: "#f3f4f6" },
  { name: "lightGrey3", code: "#e5e7eb" },
  { name: "lightGrey4", code: "#d1d5db" },
  { name: "lightGrey5", code: "#cbd5e1" },
  { name: "lightGrey6", code: "#bfc7d1" },
  { name: "slate1", code: "#a8b0bb" },
  { name: "slate2", code: "#94a3b8" },
  { name: "slate3", code: "#7c8798" },
  { name: "slate4", code: "#64748b" },
  { name: "slate5", code: "#475569" },  
  { name: "greyStrong1", code: "#9ca3af" },
  { name: "greyStrong2", code: "#6b7280" },
  { name: "greyStrong3", code: "#4b5563" },
  { name: "greyStrong4", code: "#374151" },
  { name: "greyStrong5", code: "#1f2937" },
  { name: "greyStrong6", code: "#111827" },
];

function getColor(name) {
  const code = colors.find(color => color.name === name)?.code;
  return code ?? "";
}


export const CustomHeading = styled(Heading)`
  color: ${({ color }) => getColor(color)};
  font-family: ${({ fontFamily }) => fontFamily ?? ""};
  font-size: ${({ size }) => (size ?? "18px")};
  text-align: ${({ textAlign }) => (textAlign ?? "")};
  margin: ${({ margin }) => (margin ? `${margin} !important` : "")};
  inline-size: ${({ inlineSize }) => inlineSize ?? ""};
  max-inline-size: ${({ maxInlineSize }) => maxInlineSize ?? ""};
  font-weight: ${({ fontWeight }) => fontWeight ?? 400};

  font-size: ${({ fontSize, size }) => {
    if (fontSize && Array.isArray(fontSize) && fontSize.length === 3) {
      const [min, preferred, max] = fontSize;
      const numericPreferred = parseFloat(preferred);
      const unit = preferred.replace(numericPreferred.toString(), '');
      
      const growthFactor = numericPreferred * 0.6;
      const result = `clamp(${min}, calc(${preferred} + ${growthFactor}vw), ${max})`;
      return result;
    }
    return "clamp(16px, calc(18px + 1vw), 28px)";
  }}; 

  && {
    font-size: ${({ fontSize, size }) => {
      if (fontSize && Array.isArray(fontSize) && fontSize.length === 3) {
        const [min, preferred, max] = fontSize;
        const numericPreferred = parseFloat(preferred);
        const growthFactor = numericPreferred * 0.6;
        return `clamp(${min}, calc(${preferred} + ${growthFactor}vw), ${max}) !important`;
      }
      
      if (size) {
        const numericValue = parseFloat(size);
        const unit = size.replace(numericValue.toString(), '');
        
        if (!isNaN(numericValue) && unit) {
          const minValue = Math.max(numericValue * 0.75, numericValue - 4);
          const maxValue = numericValue * 1.25;
          const growthFactor = numericValue * 0.5;
          
          return `clamp(${minValue}${unit}, calc(${size} + ${growthFactor}vw), ${maxValue}${unit}) !important`;
        }
        return `${size} !important`;
      }
      
      return "clamp(16px, calc(18px + 1vw), 28px) !important";
    }};
`;